import { Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import LogoIcon from "../../assets/images/icons/logo.svg";
import { LOGGED_IN_SESSION_KEY } from "../../constants";
import { PAGES } from "../../pages";
import { TextButton } from "../../components/base/Button";
import { LogoText } from "../../components/logoText";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  img: {
    width: 32,
  },
}));

export const Header = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.profile);
  const { cluster } = useSelector((state) => state.selectCSC);

  const logout = () => {
    localStorage.setItem(LOGGED_IN_SESSION_KEY, false);
    navigate(PAGES.login);
  };

  return (
    <>
      <Grid className={classes.root} container justifyContent="space-between" alignItems="center">
        <a href={PAGES.home}>
          <img
            className={classes.img}
            src={
              cluster?.logo
                ? `${process.env.REACT_APP_API_URL.replace("/api", "")}${cluster.logo}`
                : LogoIcon
            }
            alt="logo"
            style={{
              width: cluster?.logo_width ? cluster.logo_width : null,
            }}
          />
        </a>
        <Typography variant="h2" align="center">
          {<LogoText customerName={profileData?.customer_name} />}
        </Typography>
        <TextButton text="LOGOUT" onClick={logout} />
      </Grid>
      <Divider />
    </>
  );
};
